export default __webpack_public_path__ + "static/media/@projxctmayhem.4271c2f7.jpeg";